import type { TCustomValidationException } from '@app/_components/error/CustomValidationException';

export class CustomValidationError extends Error {
  public customValidationException: TCustomValidationException;

  constructor(customValidationException: TCustomValidationException) {
    super(customValidationException.description);
    this.customValidationException = customValidationException;
  }
}
